import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarEdit } from '@fortawesome/pro-light-svg-icons';
import { faCalendarPlus } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@zillow/constellation-10';

export const EmptyMessage: React.FC<{ onAddEventClick: React.MouseEventHandler<HTMLElement> }> = ({
  onAddEventClick,
}) => (
  <div className="flex flex-col items-center gap-4 self-stretch bg-gray-100 p-4" data-test-id="empty-events-section">
    <FontAwesomeIcon className="text-extension-foundation-primary-variant" icon={faCalendarEdit} size="5x" color="" />
    <span className="font-inter text-base font-normal leading-5">No events scheduled</span>
    <Button onClick={onAddEventClick} tone={'brand'} emphasis={'filled'} size="sm">
      <FontAwesomeIcon className={'mr-2'} icon={faCalendarPlus} />
      Add Event
    </Button>
  </div>
);
